var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ13Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 400,
    viewBox: "0 0 275 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1004_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 210,
    height: 351
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25H242V375.341H32V25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1004_471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.805 246.866H146.371C114.442 246.866 88.4542 220.879 88.4542 188.949V53.5154C88.4542 37.9074 75.7608 25.2021 60.1409 25.2021C44.5389 25.2021 31.8276 37.9074 31.8276 53.5154V188.955C31.8276 206.413 35.914 223.895 43.6169 239.562C47.2393 246.908 49.1546 255.111 49.1546 263.319V371.403C49.1546 373.574 50.9034 375.323 53.0745 375.323H185.897V307.032C185.897 304.855 187.676 303.106 189.823 303.106C191.988 303.106 193.749 304.855 193.749 307.032V375.323H238.604C240.781 375.323 242.53 373.574 242.53 371.403V291.609C242.524 266.936 222.454 246.866 197.805 246.866Z",
    fill: "#435B63"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.371 135.185C116.743 135.185 92.6177 159.298 92.6177 188.95C92.6177 218.578 116.732 242.698 146.371 242.698C176.017 242.698 200.137 218.59 200.137 188.95C200.137 159.31 176.017 135.185 146.371 135.185Z",
    fill: "#435B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ13Icon1);
export default __webpack_public_path__ + "static/media/q13-icon1.d4d2d52a909ac7b8b1686b25315fedb7.svg";
export { ForwardRef as ReactComponent };